module.exports = __webpack_public_path__ + "img/4.792c63f6.jpg";